import { Vue, Component } from 'vue-property-decorator'

@Component({
  filters: {
    portState: (value: number) => {
      if (value * 1 === 0) {
        return '待核销'
      } else if (value * 1 === 1) {
        return '已核销'
      } else if (value * 1 === 2) {
        return '已退款'
      }
    },
    portFilter: (value: number) => {
      if (value * 1 === 1) {
        return '待到账'
      } else if (value * 1 === 2) {
        return '已到账'
      } else if (value * 1 === 3) {
        return '已失效'
      }
    },
    // dataZhText: (value: any) => {
    //   let text = value
    //   if (value && typeof value === 'string') {
    //     const dArr = value.split('-')
    //     if (dArr.length == 3) {
    //       text = `${dArr[0]}年${dArr[1]}月${dArr[2]}日`
    //     }
    //   }
    //   return text
    // },
    dueTimeText: (value: any) => {
      if (value && typeof value === 'string') {
        value = value.split(' ')[0]
      }
      return value
    },
    statusTimeText: (value: any) => {
      if (value * 1 === 2) {
        return '核销时间'
      } else {
        return '下单时间'
      }
    },
    recommendTypeText: (value: number) => {
      if ((value = 1)) {
        return '推荐返利'
      } else if (value == 2) {
        return '成单返利'
      } else if (value == 3) {
        return '售后返利'
      } else if (value == 4) {
        return '评价返利'
      }
    }
  }
})
export class CommissionMixin extends Vue {}
